<form [formGroup]="form" *ngIf="!isLoading else loadingAnimation">
    <div class="images"
         formArrayName="images">
        <ng-container *ngFor="let item of array('images').controls; let i = index;">
            <div class="images_row" [formGroupName]="i">
                <ng-container [ngTemplateOutlet]="imagesRow"
                              [ngTemplateOutletContext]="{index:i}">
                </ng-container>
            </div>
        </ng-container>
    </div>
    <ng-container *ngIf="array('images').controls.length === 0 then noItems"></ng-container>
    <app-button type="primary" icon="add" (clicked)="addItem()"></app-button>
</form>


<ng-template #imagesRow let-index='index'>
    <div class="heading">
        <p class="title"> {{ 'admin.strain.tickets.reports.modal.step6.measurementNo' | translate : {number: index} }}</p>
        <div class="buttons">
            <app-circular-button *ngIf="array('images').controls.length > 1"
                                 size="small"
                                 icon="delete"
                                 type="danger"
                                 (clicked)="removeItem(index)">
            </app-circular-button>
        </div>
    </div>
    <div class="left-side">
        <app-drawing-canvas [formControl]="arrayControl(index, 'frontSideImage')"
                            [src]="getFrontSideImage(index)"
                            [showErrors]="showValidations || arrayControl(index, 'frontSideImage').touched && arrayControl(index, 'frontSideImage').invalid">
        </app-drawing-canvas>
        <app-drawing-canvas [formControl]="arrayControl(index, 'backSideImage')"
                            [src]="getBackSideImage(index)"
                            [showErrors]="showValidations || arrayControl(index, 'backSideImage').touched && arrayControl(index, 'backSideImage').invalid">
        </app-drawing-canvas>
    </div>
    <div class="right-side">
        <app-textarea
            class="observations"
            [formControl]="arrayControl(index, 'observations')"
            [showErrors]="showValidations || arrayControl(index, 'observations').invalid && arrayControl(index, 'observations').touched"
            [maxLength]="120"
            placeholder="{{'admin.strain.tickets.reports.modal.step6.observations' | translate}}">
        </app-textarea>
    </div>
</ng-template>
<ng-template #noItems let-index='index'>
    <app-alert [responsive]="true"
               type="info"
               message="{{'admin.strain.registry.create.step5.info'| translate}}">
    </app-alert>
</ng-template>


<ng-template #loadingAnimation>
    <app-loading-spinner class="loader"></app-loading-spinner>
</ng-template>
